import React from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram, FaFacebookF } from 'react-icons/fa';
import { FiMapPin, FiMail, FiPhone, FiPackage, FiHelpCircle } from 'react-icons/fi';
import { CONFIG } from '../../config/config';
// import EarlyAccessCapture from '../EarlyAccessCapture/EarlyAccessCapture';
import SubscribeCapture from '../SubscribeCapture/SubscribeCapture';
import './Footer.css';

const XLogo = () => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" aria-hidden="true">
    <path
      fill="currentColor"
      d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
    />
  </svg>
);

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <footer className="footer">
      <div className="footer-newsletter">
        <div className="container">
          <div className="newsletter-content">
            <div className="newsletter-text">
              <h3 className="newsletter-title">Early access</h3>
              <p className="newsletter-description">
                {CONFIG.CAPTURE.WHATSAPP_MESSAGE}
              </p>
            </div>
            <div className="newsletter-capture-stack">
              {/* <EarlyAccessCapture /> */}
              <SubscribeCapture />
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="footer-main">
        <div className="container">
          <div className="footer-grid">
            {/* Brand Column */}
            <div className="footer-column brand">
              <Link to="/" className="footer-logo" onClick={scrollToTop}>BASICK</Link>
              <p className="footer-tagline">
                Minimal essentials. Premium cotton.
              </p>
              <div className="social-links">
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Instagram">
                  <FaInstagram />
                </a>
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Facebook">
                  <FaFacebookF />
                </a>
                <a href="https://x.com" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="X">
                  <XLogo />
                </a>
              </div>
            </div>

            {/* Shop Column */}
            <div className="footer-column">
              <h4 className="footer-title">Shop</h4>
              <ul className="footer-links">
                <li><Link to="/products?category=t-shirts" onClick={scrollToTop}>T-Shirts</Link></li>
                <li><Link to="/coming-soon?category=hoodies" onClick={scrollToTop}>Hoodies</Link></li>
                <li><Link to="/coming-soon?category=pants" onClick={scrollToTop}>Pants</Link></li>
                <li><Link to="/coming-soon?category=accessories" onClick={scrollToTop}>Accessories</Link></li>
              </ul>
            </div>

            {/* Company Column */}
            <div className="footer-column">
              <h4 className="footer-title">Company</h4>
              <ul className="footer-links">
                <li><Link to="/about" onClick={scrollToTop}>About Us</Link></li>
                <li><Link to="/blog" onClick={scrollToTop}>Blog</Link></li>
                <li><Link to="/lookbook" onClick={scrollToTop}>Lookbook</Link></li>
                <li><Link to="/careers" onClick={scrollToTop}>Careers</Link></li>
                <li><Link to="/press" onClick={scrollToTop}>Press</Link></li>
                <li><Link to="/sustainability" onClick={scrollToTop}>Sustainability</Link></li>
                <li><Link to="/stores" onClick={scrollToTop}>Stores</Link></li>
              </ul>
            </div>

            {/* Customer Service Column */}
            <div className="footer-column">
              <h4 className="footer-title">Customer Service</h4>
              <ul className="footer-links">
                <li><Link to="/contact" onClick={scrollToTop}>Contact Us</Link></li>
                <li><Link to="/track-order" onClick={scrollToTop}><FiPackage className="link-icon" /> Track Order</Link></li>
                <li><Link to="/shipping" onClick={scrollToTop}>Shipping</Link></li>
                <li><Link to="/returns" onClick={scrollToTop}>Returns & Exchanges</Link></li>
                <li><Link to="/size-guide" onClick={scrollToTop}>Size Guide</Link></li>
                <li><Link to="/faq" onClick={scrollToTop}><FiHelpCircle className="link-icon" /> FAQ</Link></li>
                <li><Link to="/gift-cards" onClick={scrollToTop}>Gift Cards</Link></li>
              </ul>
            </div>

            {/* Legal Column */}
            <div className="footer-column">
              <h4 className="footer-title">Legal</h4>
              <ul className="footer-links">
                <li><Link to="/privacy" onClick={scrollToTop}>Privacy Policy</Link></li>
                <li><Link to="/terms" onClick={scrollToTop}>Terms of Service</Link></li>
                <li><Link to="/cookies" onClick={scrollToTop}>Cookie Policy</Link></li>
                <li><Link to="/accessibility" onClick={scrollToTop}>Accessibility</Link></li>
                <li><Link to="/sitemap" onClick={scrollToTop}>Sitemap</Link></li>
              </ul>
            </div>

            {/* Contact Column */}
            <div className="footer-column">
              <h4 className="footer-title">Contact</h4>
              <ul className="contact-list">
                <li className="contact-item">
                  <FiMapPin className="contact-icon" />
                  <span>Rohini, New Delhi</span>
                </li>
                <li className="contact-item">
                  <FiMail className="contact-icon" />
                  <a href="mailto:concierge@basick.com">concierge@basick.com</a>
                </li>
                <li className="contact-item">
                  <FiPhone className="contact-icon" />
                  <a href="tel:+12125550100">+1 (212) 555-0100</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <div className="copyright">
              © {currentYear} BASICK. All rights reserved.
              <span className="copyright-details"> {CONFIG.FOOTER.COPYRIGHT_SUFFIX}</span>
            </div>
            <div className="legal-links">
              <Link to="/privacy" onClick={scrollToTop}>Privacy</Link>
              <span className="separator">•</span>
              <Link to="/terms" onClick={scrollToTop}>Terms</Link>
              <span className="separator">•</span>
              <Link to="/cookies" onClick={scrollToTop}>Cookies</Link>
              <span className="separator">•</span>
              <Link to="/accessibility" onClick={scrollToTop}>Accessibility</Link>
            </div>
            <div className="payment-methods">
              <span className="payment-text">We Accept</span>
              <div className="payment-icons">
                <span className="payment-icon visa">Visa</span>
                <span className="payment-icon mastercard">MC</span>
                <span className="payment-icon amex">Amex</span>
                <span className="payment-icon discover">Disc</span>
                <span className="payment-icon paypal">PayPal</span>
                <span className="payment-icon applepay">Apple</span>
                <span className="payment-icon googlepay">G Pay</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Back to Top Button */}
      <button 
        className="back-to-top"
        onClick={scrollToTop}
        aria-label="Back to top"
      >
        ↑
      </button>
    </footer>
  );
};

export default Footer;